import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";

export default function LoadingButton({ loading, label, className, onClick, children, iconPos, icon, ...props }) {
  const [isClicked, setIsClicked] = useState(false);
  const isRunningRef = useRef(false);
  const releaseTimerRef = useRef(null);
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
      if (releaseTimerRef.current) {
        clearTimeout(releaseTimerRef.current);
      }
    };
  }, []);

  const handleClick = async (e) => {
    if (isRunningRef.current || loading) return;

    isRunningRef.current = true;
    setIsClicked(true);

    try {
      if (onClick) {
        const result = onClick(e);
        if (result && typeof result.then === "function") {
          await result;
        }
      }
    } finally {
      releaseTimerRef.current = setTimeout(() => {
        isRunningRef.current = false;
        if (isMountedRef.current) {
          setIsClicked(false);
        }
      }, 300);
    }
  };

  const isDisabled = loading || isClicked || props.disabled;
  const showLoading = loading || isClicked;
  const content = children || label;

  return (
    <Button
      {...props}
      className={`relative flex align-items-center justify-content-center ${className}`}
      disabled={isDisabled}
      onClick={handleClick}
    >
      {showLoading && (
        <i 
          className="pi pi-spin pi-spinner absolute"
        />
      )}
      <span 
        className={`flex gap-2 align-items-center white-space-nowrap ${showLoading ? "opacity-0" : ""}`}
      >
        {!showLoading && icon && iconPos === "left" && <i className={icon} />}
        {content || "\u00A0"}
        {!showLoading && icon && iconPos === "right" && <i className={icon} />}
      </span>
    </Button>
  );
}